import React, {ReactNode, ReactElement} from 'react';

import {Alignment} from '../../../types';
import trimClassname from '../../../utils/trimClassname';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph, {FontSize} from '../Text/Paragraph/Paragraph';

import './InformationCard.scss';

export interface InformationCardCondition {
  id: string;
  label?: string;
  description?: string;
}

export interface InformationCardProps {
  header: string;
  conditions: InformationCardCondition[];
  bordered?: boolean;
  children?: ReactNode;
  className?: string;
}

function InformationCard({header, conditions, bordered, children, className}: InformationCardProps): ReactElement {
  return (
    <div
      className={trimClassname(`informationCard ${bordered ? 'informationCard--bordered' : ''} ${className || ''}`)}
      data-testid="ui.informationCard"
    >
      <Headers headerType={HeaderType.H3} alignment={Alignment.LEFT}>
        {header}
      </Headers>
      <div className="informationCard__container">
        <div className="informationCard__description">{children}</div>
        {conditions && (
          <div className="informationCard__conditions">
            {conditions.map(({label, description, id}) => (
              <div key={id} className="informationCard__conditionBox">
                {label && <Paragraph fontSize={FontSize.MEDIUM}>{label}</Paragraph>}
                {description && <Paragraph fontSize={FontSize.MEDIUM}>{description}</Paragraph>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InformationCard;
